import AsyncStorage from "@react-native-async-storage/async-storage";
import { useIsFocused } from "@react-navigation/native";
import { SecureStorage } from "@helpers/storage";
import React, { useEffect, useState } from "react";
import { StyleSheet, Switch, Text, View } from "react-native";
import PageTitle from "../../../../components/PageTitle";
import { getFaceIdSuportIos } from "../../../../helpers/DeviceUtils";
import { IS_IOS } from "../../../../services/Config";
import * as Colors from "../../../../styles/colors";
import * as Fonts from "../../../../styles/typography";
import OptionPreference from "./components/OptionPreference";

const securityType = IS_IOS && getFaceIdSuportIos() ? "Face ID" : "Biometria";

export default function Preferences({ navigation }) {
  const [auth, setAuth] = useState(false);
  const [startsWithDigitalCredential, setStartsWithDigitalCreadential] = useState(false);

  const toggleSwitchAuth = () => {
    AsyncStorage.setItem("biometria", !auth == true ? "sim" : "não");
    if (!auth == false) {
      SecureStorage.deleteItemAsync("email");
      SecureStorage.deleteItemAsync("password");
    }

    setAuth(!auth);
  };

  const toggleSwitchstartsWithDigitalCredential = () => {
    AsyncStorage.setItem("startsWithDigitalCredential", JSON.stringify(!startsWithDigitalCredential));
    setStartsWithDigitalCreadential(!startsWithDigitalCredential);
  };

  useEffect(() => {
    (async () => {
      const auth = await AsyncStorage.getItem("biometria");
      setAuth(auth == "sim");

      const startsWithDigitalCredential = await AsyncStorage.getItem("startsWithDigitalCredential");
      setStartsWithDigitalCreadential(JSON.parse(startsWithDigitalCredential));
    })();
  }, [useIsFocused]);

  return (
    <PageTitle title={"PREFERÊNCIAS"} navigation={navigation}>
      <OptionPreference
        title={`Autentificação via ${securityType}`}
        subtitle={`Use ${securityType} para logar no sistema.\nSerá necessario logar uma vez digitando.`}
      >
        <Switch
          trackColor={{ false: "#767577", true: Colors.SECONDARY_PALLETE[2] }}
          thumbColor={auth ? Colors.SECONDARY : "#f4f3f4"}
          ios_backgroundColor="#3e3e3e"
          onValueChange={toggleSwitchAuth}
          value={auth}
        />
      </OptionPreference>
      <OptionPreference
        title={`Iniciar com Credencial Digital`}
        subtitle={`Altera a tela inicial\nA tela inicial será a credencial digital.`}
      >
        <Switch
          trackColor={{ false: "#767577", true: Colors.SECONDARY_PALLETE[2] }}
          thumbColor={startsWithDigitalCredential ? Colors.SECONDARY : "#f4f3f4"}
          ios_backgroundColor="#3e3e3e"
          onValueChange={toggleSwitchstartsWithDigitalCredential}
          value={startsWithDigitalCredential}
        />
      </OptionPreference>
    </PageTitle>
  );
}

const styles = StyleSheet.create({
  viewPrincipal: {
    flex: 1,
    padding: 16,
    paddingTop: 36,
  },
});
